import { IPickedMskuItem } from './api';
import { IMarketplaceCartLine } from './marketplace';

export enum CountryReasonEnum {
  Chosen = 'chosen',
  Detected = 'detected',
  Unknown = 'unknown',
}

export interface ICountryNotice {
  id: number;
  message: string;
}

export interface ISuspendedPick {
  pickedCampaignId: string;
  pickedItems: { [id: string]: IPickedMskuItem } | null;
}

export interface ISuspendedSelection {
  pick: ISuspendedPick | null;
  cart: IMarketplaceCartLine[] | null;
}

export interface ISelectionScope {
  pick: boolean;
  cart: boolean;
}

export interface IGetFormDataRequestMeta {
  countryChange?: boolean;
  requestId?: string;
  afterAuth?: boolean;
}
